import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const AnimatedItem = ({ 
  children, 
  delay = 0, 
  direction = 'up', 
  className = '' 
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  // Define initial positions based on direction
  const getInitialPosition = () => {
    switch (direction) {
      case 'left':
        return { opacity: 0, x: -50, y: 0 };
      case 'right':
        return { opacity: 0, x: 50, y: 0 };
      case 'down':
        return { opacity: 0, x: 0, y: -30 };
      case 'up':
      default:
        return { opacity: 0, x: 0, y: 30 };
    }
  };

  const animatePosition = { opacity: 1, x: 0, y: 0 };

  return (
    <motion.div
      ref={ref}
      initial={getInitialPosition()}
      animate={isInView ? animatePosition : getInitialPosition()}
      transition={{ 
        duration: 0.35, 
        delay,
        ease: [0.25, 0.46, 0.45, 0.94]
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedItem;

